import { Colors } from '~/themes/colors';

export const CalendarSolidIcon = ({ color = Colors.secondary_500 }) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.1999 2.3999C6.53716 2.3999 5.9999 2.93716 5.9999 3.5999V4.7999H4.7999C3.47442 4.7999 2.3999 5.87442 2.3999 7.1999V19.1999C2.3999 20.5254 3.47442 21.5999 4.7999 21.5999H19.1999C20.5254 21.5999 21.5999 20.5254 21.5999 19.1999V7.1999C21.5999 5.87442 20.5254 4.7999 19.1999 4.7999H17.9999V3.5999C17.9999 2.93716 17.4626 2.3999 16.7999 2.3999C16.1372 2.3999 15.5999 2.93716 15.5999 3.5999V4.7999H8.3999V3.5999C8.3999 2.93716 7.86264 2.3999 7.1999 2.3999ZM7.1999 8.3999C6.53716 8.3999 5.9999 8.93716 5.9999 9.5999C5.9999 10.2626 6.53716 10.7999 7.1999 10.7999H16.7999C17.4626 10.7999 17.9999 10.2626 17.9999 9.5999C17.9999 8.93716 17.4626 8.3999 16.7999 8.3999H7.1999Z"
      fill={color}
    />
  </svg>
);
